import { log } from 'log';
import { getBaseDomain } from 'js/utils/url.util';
import { disablePopupsAction, enablePopupsAction } from 'js/components/common/PopupManager';

export const init = () => {
    const domain = getBaseDomain({ dotStart: false });

    log('info', '[UCIP]: Init');

    try {
        document.domain = domain;

        log('info', '[UCIP]: Domain was changed to ', domain);
    } catch (e) {
        log('error', '[UCIP]: Can not change domain to ', domain);
    }
};

export const parseMessage = (event) => {
    try {
        if (event?.data) {
            log('info', '[UCIP]: Receive: ', event.data);

            return JSON.parse(event.data);
        }
    } catch (e) {
        log('warn', '[UCIP]: Post message ca not be parsed: ', event);
    }
};

export const sendMessage = (message) => {
    try {
        const json = JSON.stringify(message);

        document.querySelector('.game-iframe').contentWindow.postMessage(json, '*');

        log('info', '[UCIP]: Sent: ', JSON.stringify(message));
    } catch (e) {
        log('error', '[UCIP]: Post message can not be sent: ', message);
    }
};

export const onMessage = (event, methods) => {
    const featureList = ['displaystatus', 'switchgame', 'autoplay', 'pause'];
    const { getWrapperLaunchUrl, dispatch, setFeatures, setIsInitialized } = methods;
    const message = parseMessage(event);

    log('info', '[UCIP]: ', event);

    // eslint-disable-next-line no-underscore-dangle
    const type = message?._type;
    const features = message?.features || [];

    switch (type) {
        case 'ucip.basic.g2wInitializationRequest': {
            const supportedFeatures = featureList.filter((feature) => features.includes(feature));

            setFeatures?.(supportedFeatures);
            setIsInitialized?.(true);

            sendMessage({
                _type: 'ucip.basic.w2gInitializationResponse',
                version: '1.0.0',
                features: supportedFeatures
            });

            break;
        }

        case 'ucip.basic.g2wCloseGameFrameCommand':
            log('info', '[UCIP]: Close game');

            if (window.opener) {
                // close current browser window
                window.close();
            } else {
                location.href = location.origin;
            }

            break;

        case 'ucip.switchgame.g2wSwitchGameCommand':
            log('info', '[UCIP]: Switch game');

            if (getWrapperLaunchUrl && message?.gameCode) {
                const launchUrl = getWrapperLaunchUrl({
                    gameCode: message.gameCode,
                    mode: 1
                });

                if (launchUrl) {
                    log('info', '[UCIP]: Switching to game with ID:', message.gameCode);
                    window.location.href = launchUrl;
                } else {
                    log('error', '[UCIP]: Failed to get launch URL for game ID:', message.gameCode);
                }
            } else {
                log('error', '[UCIP]: Cannot switch game - getWrapperLaunchUrl function not available or gameId not provided');
            }

            break;

        case 'ucip.displaystatus.g2wUiStateNotification':
            log('info', '[UCIP]: Display status');

            if (message?.busy === true) {
                dispatch?.(disablePopupsAction());
            } else if (message?.busy === false) {
                dispatch?.(enablePopupsAction());
            }

            break;

        case 'ucip.autoplay.g2wAutoplayStartNotification':
            log('info', '[UCIP]: Autoplay Start');

            dispatch?.(disablePopupsAction());

            break;

        case 'ucip.autoplay.g2wAutoplayEndNotification':
            log('info', '[UCIP]: Autoplay End');

            dispatch?.(enablePopupsAction());

            break;

        case 'ucip.pause.g2wPauseNotification':
            log('info', '[UCIP]: Pause');

            if (message?.pause === false) {
                dispatch?.(disablePopupsAction());
            } else if (message?.pause === true) {
                dispatch?.(enablePopupsAction());
            }

            break;

        default:
        // noop
    }
};
